module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/tag-create/tag-create.component.scss
// module id = ./src/app/tags/tag-create/tag-create.component.scss
// module chunks = main